import { LoadableSettings } from "features";
import React from "react";
import { Breadcrumb } from "shared/ui/components";

export default function SettingsPage() {
  return (
    <>
      <Breadcrumb />
      <LoadableSettings />
    </>
  );
}
